import React from 'react';
import PropTypes from 'prop-types';

const StreamingPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.326 27A5.74 5.74 0 0 0 5 19.674v-2.982A8.609 8.609 0 0 1 15.308 27h-2.982zm5.907 0c.104-.622.158-1.261.158-1.913 0-6.34-5.139-11.478-11.478-11.478-.652 0-1.29.054-1.913.158v-2.901a14.48 14.48 0 0 1 1.913-.127c7.924 0 14.348 6.424 14.348 14.348 0 .649-.043 1.287-.127 1.913h-2.901zm5.792 0c.07-.628.105-1.266.105-1.913 0-9.509-7.708-17.217-17.217-17.217-.647 0-1.285.035-1.913.105V5.09C5.63 5.03 6.268 5 6.913 5 18.007 5 27 13.993 27 25.087c0 .645-.03 1.283-.09 1.913h-2.885zM7.391 27a2.391 2.391 0 1 1 0-4.783 2.391 2.391 0 0 1 0 4.783z"
    />
  );
};

StreamingPath.propTypes = {
  fill: PropTypes.string,
};

export default StreamingPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/streaming.jsx